<template>
  <section>
    <article>
      <infinite-scroll class="contributions" :callback="getContributions">
        <contribution-card :contribution="contribution" v-for="contribution in contributions" :key="contribution.id"></contribution-card>
        <span class="loader" v-if="loading"></span>
      </infinite-scroll>
    </article>
    <article v-if="!loading && contributions.length === 0">
      <p>{{placeholder}}</p>
    </article>
  </section>
</template>

<script>
import InfiniteScroll from '@/components/Controls/InfiniteScroll'
import ContributionCard from '@/components/UIContributionCard'
import componentState from '@/mixins/component-state'

import state from '../state'
import i18n from '@/i18n'

export default {
  components: {
    InfiniteScroll,
    ContributionCard
  },
  mixins: [componentState],
  props: ['user', 'profile'],
  data: function () {
    return {
      contributions: [],
      limit: 12,
      offset: 0,
      hasMore: true,
      loading: false
    }
  },
  computed: {
    placeholder: function () {
      return this._get(state.editable.profile, false) ? i18n.t('sectionProfile.contributionMessage') : this.user.userName + i18n.t('sectionProfile.noContributions')
    }
  },
  mounted: function () {
    this.getContributions()
  },
  watch: {
    user: function () {
      this.getContributions()
    }
  },
  methods: {
    getContributions: function () {
      if (this.loading || !this.hasMore || !this.user.userName) {
        return
      }

      this.loading = true
      const filter = ''
      const contributionConfig = { username: this.user.userName, limit: this.limit, offset: this.offset, filter }
      this.$store.dispatch('getContributions', contributionConfig).then((response) => {
        this.contributions.push.apply(this.contributions, response.contributions)
        this.hasMore = response.hasMore
        this.loading = false
        this.offset += this.limit
      }, (messages) => {
        this.contributions.loading = false
        this.handleError(messages)
      })
    }
  }
}

</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.contributions {
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  @include mobile {
    width: 100vw;
    margin: 0 -1rem;
  }

  .loader {
    display: block;
    font-size: 2rem;
    margin: 1rem auto;
  }
}
</style>
